import { DefaultValue } from "recoil";

export const guardRecoilDefaultValue = (state: any): state is DefaultValue => {
  if (state instanceof DefaultValue) return true;
  return false;
};
